import Tabs from './Tabs';
import Pane from './Pane';

export {
  Tabs,
  Pane
};



/** WEBPACK FOOTER **
 ** ./src/components/common/ui/tabs/index.js
 **/